import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";

export const VideoPlayer = (props) => {

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Video Preview
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="player-wrapper">
                    <ReactPlayer
                        url={props?.selectedItem?.link}
                        controls
                        width="100%"
                        height="100%"
                        playing={true}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" onClick={props.onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
